import axios from "axios";
import { COURSE_SERVICE_URL, SERVICE_URL, getHeaders } from "@/apis/common";

export function addUser(payload) {
  const url = `${SERVICE_URL}/users`;
  const headers = {
    "Content-Type": "application/json",
  };
  const config = {
    headers,
  };

  return axios.post(url, payload, config).then(res => res.data);
}

export function getUsers(token) {
  const url = `${SERVICE_URL}/users`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function updateUser(token, id, payload) {
  const url = `${SERVICE_URL}/users/${id}`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.patch(url, payload, config).then(res => res.data);
}

export function deleteUser(token, id) {
  const url = `${SERVICE_URL}/users/${id}`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.delete(url, config).then(res => res.data);
}

export function addOrGetCourseServiceUser(token, uid) {
  const url = `${COURSE_SERVICE_URL}/private/user/${uid}`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.post(url, {}, config).then(res => res.data);
}
